import Text from '@common/components/Text/Text'

import { ENavigator } from '../../navigator'

import styles from './Congratulations.css'

class Congratulations extends HTMLElement {
  public connectedCallback (): void {
    this.appendChild(
      <Fragment>
        <div className={ styles.title }>
          <Text.instance key="activator.congratulations" />
        </div>

        <a-button-container>
          <a-button action={ ENavigator.Start } icon="start" key="activator.button.start" />
        </a-button-container>
      </Fragment>
    )
  }
}

customElements.define('a-congratulations', Congratulations)
